<template>
  <div>
    <v-app-bar
      color="primary"
      dark
      app
      clipped-left
      :style="'margin-top: ' + top + 'px'"
    >
      <div class="mr-4">
        <v-img
          src="/static/platformgold-logo-dark.png?v=1.79.0"
          alt="PlatformGold&reg;"
          width="240"
          contain
        />
      </div>
      <!-- Full screen menu -->
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <div 
          class="d-flex justify-center flex-grow-1" 
        >
          <template v-for="(item, key) in computeMenu">
            <v-btn
              v-if="!item.children"
              :key="'fsMenu_' + key + '_btn'"
              :to="item.path"
              :color="refineNavColor(item)"
              :dark="refineNavColor(item) === 'primary'"
              depressed
              :class="['mx-1', refineNavPulseClass(item)]"
            >{{ item.meta.title }}
            </v-btn>
            <v-menu v-else offset-y :key="'fsMenu_' + key + '_menu'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="refineNavColor(item)"
                  :dark="refineNavColor(item) === 'primary'"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  :class="['mx-1', refineNavPulseClass(item)]"
                >
                  {{ item.meta.title }}
                </v-btn>
              </template>
              <v-list>
                <template v-for="(subItem, index) in item.children">
                  <v-divider
                    v-if="subItem.meta.separator === 'before'"
                    :key="'fsMenu_' + key + '_' + index + '_divider_before'"
                    class="my-1"
                  />
                  <v-list-item
                    :key="'fsMenu_' + key + '_' + index"
                    :to="subItem.path"
                  >
                    <v-list-item-title v-text="__('menu.' + subItem.meta.title)"/>
                  </v-list-item>
                  <v-divider
                    v-if="subItem.meta.separator === 'after' || subItem.meta.separator === true"
                    :key="'fsMenu_' + key + '_' + index + '_divider_after'"
                    class="my-1"
                  />
                </template>
              </v-list>
            </v-menu>
          </template>
          <v-menu
            offset-y
            origin="center center"
            transition="scale-transition"
            :close-on-content-click="false"
            v-model="profileMenuOpen"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark depressed v-bind="attrs" v-on="on" class="mx-1">
                Settings
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item class="pt-4" v-if="getTradingRoles.length > 1">
                <trading-role-selector
                  v-on:selected="changeTradingRole()"
                ></trading-role-selector>
              </v-list-item>
              <profile-menu v-on:close="profileMenuOpen=false"></profile-menu>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template v-else>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      </template>
      <!-- Full Screen User Menu -->
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <div class="d-flex align-center">
          <v-container
            v-if="
              isAdmin() ||
                Object.keys(lodash.get(getUserProfile, `companyPermissions`, {}))
                  .length > 1
            "
          >
            <v-btn text dark to="/user/companies"
            >{{ getSelectedCompany.name }}
            </v-btn>
          </v-container>
          <v-btn v-if="authorizedTraders() && fullAccessCompanyOnly()" text @click="showTradeTicket()">
            <v-badge
              v-if="getTotalCartCount > 0"
              bordered
              top
              color="secondary"
              :content="getTotalCartCount"
              offset-x="10"
              offset-y="10"
              rounded="circle"
            >
              <v-icon
                :style="`transform: rotate(35deg);`"
                color="secondary"
              >
                mdi-ticket
              </v-icon>
            </v-badge>
            <v-icon
              :style="`transform: rotate(35deg);`"
              color="secondary"
              v-else
            >
              mdi-ticket
            </v-icon>
            <span class="ml-2">Trade Ticket</span>
          </v-btn>
          <v-menu
            v-model="alertsMenu"
            offset-y
            origin="center center"
            transition="scale-transition"
            :close-on-content-click="true"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on">
                <v-badge
                  dot
                  left
                  color="red"
                  content="1"
                  offset-x="10"
                  offset-y="10"
                  v-if="getConfig('UNREAD_ALERTS_COUNT') > 0"
                >
                  <v-icon color="secondary"> mdi-bell</v-icon>
                </v-badge>
                <v-icon color="secondary" v-else> mdi-bell</v-icon>
              </v-btn>
            </template>
            <alerts-list :alerts="getConfig('UNREAD_ALERTS_ROWS')"/>
          </v-menu>
          <v-btn v-if="getUserProfile.isAdmin && this.getUserProfile.accessCallLogWidget" color="primary" elevation="0">
            <v-icon
              color="secondary"
              @click="openCallLog"
            >
              mdi-phone
            </v-icon>
          </v-btn>
        </div>
      </template>
      <v-toolbar
        v-if="breadcrumbActive"
        tag="div"
        dense
        slot="extension"
        color="white"
        light
      >
        <v-icon>mdi-home</v-icon>
        <v-breadcrumbs :items="breadcrumbs" class="pa-3"/>
        <v-spacer></v-spacer>
        <v-btn icon small color="black">
          <v-icon v-text="'mdi-arrow-left'" @click="handleGoBack"/>
        </v-btn>
      </v-toolbar>
    </v-app-bar>
    <!-- Navigation drawer (md and lower) -->
    <v-navigation-drawer v-model="drawer" temporary right app>
      <template
        v-if="
          isAdmin() ||
            Object.keys(lodash.get(getUserProfile, `companyPermissions`, {}))
              .length > 1
        "
      >
        <v-list-item-title @click="drawer = false">
          <v-btn width="100%" text to="/user/companies"
          >{{ getSelectedCompany.name }}
          </v-btn>
        </v-list-item-title>
        <v-divider></v-divider>
      </template>
      <template v-if="getTradingRoles.length > 1">
        <v-list-item>
          <trading-role-selector
            v-on:selected="changeTradingRole()"
          ></trading-role-selector>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <v-list-item to="/alerts" @click="drawer = false">
        <v-list-item-icon>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="secondary" v-bind="attrs" v-on="on">
                mdi-bell
              </v-icon>
            </template>
            <span>Alerts</span>
          </v-tooltip>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
          >Alerts
            <v-badge
              class="ml-1"
              v-if="getConfig('UNREAD_ALERTS_COUNT') > 0"
              color="red"
              :content="getConfig('UNREAD_ALERTS_COUNT')"
            ></v-badge>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="showTradeTicket" v-if="authorizedTraders() && fullAccessCompanyOnly()">
        <v-list-item-icon>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :style="`transform: rotate(35deg);`"
                color="secondary"
                v-bind="attrs"
                v-on="on"
              >
                mdi-ticket
              </v-icon>
            </template>
            <span>Trade Ticket</span>
          </v-tooltip>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
          >Trade Ticket
            <v-badge
              class="ml-1"
              v-if="getTotalCartCount > 0"
              color="red"
              :content="getTotalCartCount"
              rounded="circle"
            ></v-badge>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <template v-for="(item, key) in computeMenu">
        <template v-if="item.children && item.children.length > 0">
          <v-list-group :key="'rm_' + key" no-action :to="item.path" :class="refineNavPulseClass(item)">
            <template v-slot:prependIcon>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    v-text="item.meta.icon"
                    :color="refineNavColor(item) === 'secondary' ? 'secondary' : undefined"
                  />
                </template>
                <span>
                  {{ __('menu.' + item.meta.title) }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  v-text="__('menu.' + item.meta.title)"
                  :class="refineNavColor(item) === 'secondary' ? 'secondary--text' : ''"
                />
              </v-list-item-content>
            </template>
            <template v-for="(subItem, subKey) in item.children">
              <v-divider
                v-if="subItem.meta.separator === 'before'"
                :key="'rm_' + key + '_' + subKey + '_divider_before'"
                class="my-1"
              />
              <v-list-item
                :key="'rm_' + key + '_' + subKey"
                :to="subItem.path"
                v-show="!subItem.meta.hiddenInMenu"
              >
                <template>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="__('menu.' + subItem.meta.title)"
                    />
                  </v-list-item-content>
                </template>
              </v-list-item>
              <v-divider
                v-if="subItem.meta.separator === 'after' || subItem.meta.separator === true"
                :key="'rm_' + key + '_' + subKey + '_divider_after'"
                class="my-1"
              />
            </template>
          </v-list-group>
        </template>
        <template v-else>
          <v-list-item
            :key="(key + 1) * 100"
            :to="item.path"
            v-show="!item.meta.hiddenInMenu"
            :class="refineNavPulseClass(item)"
          >
            <v-list-item-icon>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    v-text="item.meta.icon"
                    :color="refineNavColor(item) === 'secondary' ? 'secondary' : undefined"
                  />
                </template>
                <span>{{ __('menu.' + item.meta.title) }}</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="__('menu.' + item.meta.title)"
                :class="refineNavColor(item) === 'secondary' ? 'secondary--text' : ''"
              />
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
      <v-divider></v-divider>
      <profile-menu></profile-menu>
    </v-navigation-drawer>
  </div>
</template>
<script>
import Util from '@/util'
import {mapGetters} from 'vuex'
import _ from 'lodash'
import {routes} from '@/router/config'
import Vue from 'vue'
import guardsMixin from '@/mixins/guards'
import featureFlagsMixin from '@/mixins/featureFlags'
import TradingRoleSelector from '@/components/user/TradingRoleSelector'
import AlertsList from '@/components/widgets/AlertsList'
import ProfileMenu from "@/components/ProfileMenu";
import {refineNavColor, refineNavPulseClass} from '@/util/refinery/postLoginDestination'

export default {
  name: 'AppToolbar',
  mixins: [guardsMixin, featureFlagsMixin],
  components: {ProfileMenu, TradingRoleSelector, AlertsList},
  data() {
    return {
      profileMenuOpen: false,
      breadcrumbActive: false,
      drawer: false,
      alertsMenu: false,
      lodash: _,
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedCompany',
      'getTotalCartCount',
      'getUsername',
      'getConfig',
      'getOverdueInvoiceCount',
      'getTradingRoles',
      'getUserProfile',
    ]),
    top() {
      const alertBannerHeight = this.getConfig('ALERT_BANNER_ENABLED') ? 24 : 0
      const overdueInvoiceRibbonHeight =
        this.featureFlags.PAY_NOW_ENABLED && this.getOverdueInvoiceCount > 0 ? 24 : 0
      return 24 + alertBannerHeight + overdueInvoiceRibbonHeight // Use new ticker height (24)
    },
    computeGroupExpanded(item, $route) {
      if ($route)
        return $route.matched.map((item) => item.path).includes(item.path)
      else return false
    },
    computeMenu() {
      // Define the desired order
      const desiredOrder = ['Dashboard', 'Trade', 'Orders', 'Charts', 'Resources', 'Admin'];

      const items = routes().filter(
        (route) => route.meta && route.meta.navRoot
      )[0].children;

      // pass isTopLevel = true for top-level menu
      const filteredItems = this.filterMenu(items, true);

      // Sort the filtered items according to the desired order
      const sortedItems = filteredItems.sort((a, b) => {
        const indexA = desiredOrder.indexOf(a.meta.title);
        const indexB = desiredOrder.indexOf(b.meta.title);

        // Handle items not in the desiredOrder list (put them at the end)
        if (indexA === -1 && indexB === -1) return 0; // Keep original relative order if both are not specified
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
      });

      // Move invoices to the bottom of the orders dropdown
      sortedItems.forEach(item => {
        if (item.meta.title === 'orders' && item.children) {
          // Sort children to put invoices last
          item.children.sort((a, b) => {
            if (a.meta.title === 'invoices') return 1;
            if (b.meta.title === 'invoices') return -1;
            return 0;
          });
        }
      });

      return sortedItems;
    },
    breadcrumbs() {
      const {matched} = this.$route
      return matched
        .map((route, index) => {
          const to =
            index === matched.length - 1
              ? this.$route.path
              : route.path || route.redirect
          const text = this.$vuetify.lang.t('$vuetify.menu.' + route.meta.title)
          return {
            text: text,
            to: to,
            exact: true,
            disabled: false,
            hiddenInMenu: _.get(route, `meta.hiddenInMenu`, false),
          }
        })
        .filter((item) => {
          return _.get(item, `hiddenInMenu`, false) === false
        })
    },
  },
  methods: {
    openCallLog() {
      window._VMA.$emit('SHOW_CALL_LOG_WIDGET')
    },
    changeTradingRole() {
      this.profileMenuOpen = false
      window._VMA.$emit('ONLINE')
    },
    refineNavColor(item) {
      return refineNavColor(item, this.getSelectedCompany, this.getUserProfile)
    },
    refineNavPulseClass(item) {
      return refineNavPulseClass(item, this.getSelectedCompany, this.getUserProfile)
    },
    filterMenu(items, isTopLevel = false) {
      return items
        .filter((item) => {
          // filter out settings if it's a top-level menu item
          if (
            isTopLevel &&
            item.meta &&
            item.meta.title &&
            item.meta.title.trim().toLowerCase() === 'settings'
          ) {
            return false;
          }
          if (_.get(item, `meta.hiddenInMenu`, false)) {
            return false
          }
          const guards = _.get(item, 'meta.guards')
          let redirect = undefined
          _.forEach(guards, (guard) => {
            if (redirect === undefined) redirect = guard()
          })
          return redirect === undefined
        })
        .map((item) => {
          if (item.children) {
            item.children = this.filterMenu(item.children, false)
          }
          return item
        })
    },
    handleDrawerToggle() {
      this.$emit('side-icon-click')
    },
    handleFullScreen() {
      Util.toggleFullScreen()
    },
    handleChangeLocale({value}) {
      this.$vuetify.lang.current = value
    },
    handleSetting() {
      this.$router.push('/user/settings')
    },
    goToAddressBook() {
      this.$router.push('/addresses')
    },
    handleGoBack() {
      this.$router.go(-1)
    },
    showTradeTicket() {
      if (this.drawer === true) {
        // Workaround for https://github.com/vuetifyjs/vuetify/issues/5356
        this.drawer = false
        Vue.nextTick().then(function () {
          document.documentElement.classList.add('overflow-y-hidden')
        })
      }
      window._VMA.$emit('SHOW_TRADE_TICKET')
    },
  },
  created() {
  },
}
</script>

<style lang="sass" scoped>
@keyframes refine-now-pulse
  0%, 100%
    opacity: 1
  50%
    opacity: 0.55

.refine-now-pulse
  animation: refine-now-pulse 1.6s ease-in-out infinite

// Force trade ticket badge to be circular, smaller, and centered
::v-deep .v-badge__badge
  border-radius: 50% !important
  height: 18px !important
  min-width: 18px !important
  font-size: 0.65rem !important // Slightly smaller font
  line-height: 18px !important // Match height for vertical centering
  padding: 0 3px !important // Adjust padding slightly
  // Ensure text alignment just in case
  text-align: center !important
  display: inline-flex !important
  align-items: center !important
  justify-content: center !important
</style>

